'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { track404 } from '@lib/tracking';
import Navigation from '@content/navigation/Navigation';
import MiniFooter from '@content/navigation/MiniFooter';
import Section from '@dvd/components/Section';
import HeroDefault from '@dvd/modules/Heroes/HeroDefault';

const LENNY_GALLERY = 'https://fast.wistia.net/embed/channel/24076kc8tf';

const NotFound = () => {
  const pathname = usePathname();

  useEffect(() => {
    // Track 404 page view on mount
    track404(pathname);
  }, [pathname]);

  return (
    <>
      <Navigation />
      <main>
        <Section colorScheme="orange">
          <HeroDefault
            title="Page Not Found"
            headline="Oops! We couldn't find that page."
            description="The page you're looking for doesn't exist or may have been moved. Let's get you back on track."
            video={{
              hashedId: 'j99ficzros',
              aspect: 1.7777777777777777,
            }}
            showLogos={false}
            primaryCta={{
              text: 'Go Home',
              href: '/',
            }}
            secondaryCta={{
              text: 'See More Lenny',
              href: LENNY_GALLERY,
            }}
          />
        </Section>
      </main>
      <MiniFooter />
    </>
  );
};

export default NotFound;
